module.exports = __webpack_public_path__ + "assets/54b0d9ab92b5db626dcc3a3a014e86bf.png";